<template>
  <div class="monthly">
    <div ref="head">
      <div class="tap-bar">
        <div :class="['tap', tap !== 0 || 'pitchOn']" @click="$router.push('/monthly?tap=0&date1=' + date1)">
          <span>总汇总</span></div>
        <div
          :class="['tap', 'pitchOn']"
        >
          <span>分月明细</span>
        </div>
        <div :class="['tap', tap !== 2 || 'pitchOn']" @click="$router.push('/monthly?tap=2&date1=' + date1)">
          <span>分类汇总</span></div>
      </div>
    </div>
    <div class="seek">
      <div class="date-box" @click="show = true">
        <van-icon name="clock-o"/>
        <span class="time">{{date1}}</span>
      </div>
      <p v-if="lastest">数据更新至：{{lastest}}</p>
      <p>单位：千元</p>
    </div>

    <div class="tt-content">
      <div
        class="ive-box"
        ref="iveBox"
        @touchmove.stop.prevent="iveBoxTouch"
        @touchstart="iveBoxStart"
        @touchend="iveBoxEnd"
      >
        <div class="ive-header" ref="header">
          <table cellspacing="0" cellpadding="0" border="0" :style="iveWidth" class="ive-table" ref="iveHeader">
            <colgroup>
              <col v-for="(column, index) in header" :width="column.width" :key="index">
            </colgroup>
            <thead>
            <tr>
              <th
                v-for="(item, index) of header" :key="index"
                :class="alignCls(item)"
              >
                <div class="ive-th" :style="{width: `${item.width - 1}px`}">
                  {{item.title}}
                </div>
              </th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="ive-body" :style="iveBody" ref="tbody">
          <table cellspacing="0" cellpadding="0" border="0" :style="tableBody" class="ive-table" ref="tbodyes">
            <colgroup>
              <col v-for="(column, index) in header" :width="column.width" :key="index">
            </colgroup>
            <tbody>
            <tr v-for="(row, index) of data" :key="index">
              <td
                v-for="(column, cellIndex) of header" :key="index + 'a' + cellIndex"
                :class="alignCls(column)"
              >
                <div class="ive-tr-td" :style="{width: `${column.width - 1}px`}" ref="iveTrTd">
                  <span v-if="!column.render">{{row[column['key']]}}</span>
                  <render-td
                    v-else
                    :row="row"
                    :column="column"
                    :index="index"
                    :render="column.render"
                  ></render-td>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="ive-left-fixed" :style="leftFixedBoxStyle">
          <div class="ive-left-fixed-header">
            <table cellspacing="0" cellpadding="0" border="0" :style="leftIveWidth" class="ive-table">
              <colgroup>
                <col v-for="(column, index) in fixedHeaderEs" :width="column.width" :key="index">
              </colgroup>
              <thead>
              <tr>
                <th
                  v-for="(item, index) of fixedHeaderEs" :key="index"
                  :class="alignCls(item)"
                >
                  <div class="ive-th" :style="{width: `${item.width - 1}px`}">
                    {{item.title}}
                  </div>
                </th>
              </tr>
              </thead>
            </table>
          </div>
          <div class="ive-left-fixed-body" :style="iveLeftFixedBoxStyle" ref="fixedBody">
            <table cellspacing="0" cellpadding="0" border="0" :style="leftTableBody" class="ive-table"
                   ref="leftFixedBox">
              <colgroup>
                <col v-for="(column, index) in fixedHeaderEs" :width="column.width" :key="index">
              </colgroup>
              <tbody>
              <tr v-for="(row, index) of data" :key="index">
                <td
                  v-for="(column, cellIndex) of fixedHeaderEs" :key="index + 'a' + cellIndex"
                  :class="alignCls(column)"
                >
                  <div class="ive-tr-td" :style="{width: `${column.width - 1}px`}" ref="iveTrTd">
                    <span v-if="!column.render">{{row[column['key']]}}</span>
                    <render-td
                      v-else
                      :row="row"
                      :column="column"
                      :index="index"
                      :render="column.render"
                    ></render-td>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div :class="iveNotData">
          <p>没有更多数据了~~</p>
        </div>
      </div>
      <div class="toTop">
        <div class="to-top">
          <van-icon name="arrow-up" size="30" @click="toTop"/>
        </div>
        <div class="to-bottom">
          <van-icon name="arrow-down" size="30" @click="toBottom"/>
        </div>
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '280px' }"
    >
      <van-datetime-picker
        v-model="date"
        type="year-month"
        @confirm="confirmOk"
        @cancel="show = false"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
  import {monthly} from '../../api/v1'
  import {deepCopy, forEachs, getTimes, upOfDown} from '../../utils'
  import RenderTd from './../../components/table-scroll/render-td'

  export default {
    name: 'monthly',
    data() {
      return {
        tap: 1,
        show: false,
        header: [],
        data: [],
        iveSize: {},
        startTouch: {},
        endTouch: {},
        touchY: 0,
        touchX: 0,
        scrollTop: 0,
        scrollLeft: 0,
        iveHeadHeight: 0,
        maxScrollY: 0,
        scrollEndY: 0,
        scrollEndX: 0,
        iveNotStatus: false,
        timeOut: null,
        date: '',
        lastest: ''
      }
    },
    created() {
      let qu = this.$route.query
      let date = getTimes('Y-M')
      if (qu.date1) date = qu.date1
      this.date = new Date(date)
      this.date1 = getTimes('Y-M', date)
      this.cutTap()
    },
    methods: {
      getList(type) {
        return new Promise((resolve, reject) => {
          monthly.getMonthlyList({
            total_month: getTimes('YM', this.date1),
            data_type: type
          }).then(res => {
            if (res.code === 200) {
              this.lastest = res.data.lastest
              resolve(res.data)
            }
          }).catch(err => reject(err))
        })
      },
      cutTap() {
        this.getList('分月明细').then(res => {
          this.data = res.data.map(item => Object.freeze(item)).filter(item => item.pid === 0)
          // console.log(this.data[1]['1月'] = 2);
          // Object.defineProperties()
          this.header = res.columns.map(item => {
            let obj = {
              title: item,
              key: item,
              align: 'right',
              width: 60
            }
            if (!['类型', '任务指标', '事业部', '店名', '负责人', '平台', '品牌', '渠道'].includes(item)) {
              obj.render = (h, p) => {
                let text = p.row[item]
                if (p.row['任务指标'] === 'Ev%') {
                  return h('div', {class: 'td-down-of-up'}, [
                    h('span', text),
                    h('i', {class: upOfDown(text)})
                  ])
                } else {
                  return h('span', text)
                }
              }
            } else if (!['任务指标'].includes(item)) {
              obj.headerAlign = 'center'
              obj.align = 'left'
            }
            if (['事业部', '店名'].includes(item)) {
              obj.fixed = 'left'
            }
            return obj
          })

          this.$nextTick(() => {
            let size = this.$refs.iveBox
            this.iveSize = {width: size.offsetWidth, height: size.offsetHeight}
            this.iveHeadHeight = this.$refs.header.offsetHeight
            let tds = this.$refs.iveTrTd
            if (tds) {
              forEachs(tds, item => {
                if (item.offsetWidth < item.children[0].offsetWidth) {
                  item.addEventListener('touchmove', (e) => {
                    e.stopPropagation()
                  })
                }
              })
            }
          })
        })
      },
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`
        } else if (type === 'month') {
          return `${value}月`
        }
        return value
      },
      confirmOk(e) {
        this.date = e
        this.date1 = getTimes('Y-M', e)
        this.show = false
        this.cutTap()
      },
      alignCls(column) {
        return [
          {
            [`${column.className}`]: column.className, // column className
            [`ive-column-${column.align}`]: column.align,
            [`ive-header-${column.headerAlign}`]: column.headerAlign,
            [`ive-hidden`]: (this.fixed === 'left' && column.fixed !== 'left') || (this.fixed === 'right' && column.fixed !== 'right') || (!this.fixed && column.fixed && (column.fixed === 'left' || column.fixed === 'right'))
          }
        ]
      },
      iveBoxTouch(e) {
        let max = this.maxTopLeft
        this.touchY = e.touches[0].clientY
        this.touchX = e.touches[0].clientX
        this.scrollTop = (this.startTouch.y - this.touchY) + this.scrollEndY
        this.scrollLeft = (this.startTouch.x - this.touchX) + this.scrollEndX
        this.scrollTop = this.scrollTop >= max.top ? max.top : this.scrollTop <= 0 ? 0 : this.scrollTop
        this.scrollLeft = this.scrollLeft >= max.left ? max.left : this.scrollLeft <= 0 ? 0 : this.scrollLeft
        this.$refs.tbodyes.style.transform = `translate(-${this.scrollLeft}px, -${this.scrollTop}px) scale(1) translateZ(0px)`
        this.$refs.iveHeader.style.transform = `translate(-${this.scrollLeft}px, 0px) scale(1) translateZ(0px)`
        this.$refs.fixedBody.style.transform = `translate(0px, -${this.scrollTop}px) scale(1) translateZ(0px)`
        if (this.scrollTop === max.top) {
          this.iveNotStatus = true
          if (this.timeOut) clearTimeout(this.timeOut)
          this.timeOut = setTimeout(() => {
            this.iveNotStatus = false
          }, 3000)
        }
      },
      iveBoxStart(e) {
        this.startTouch = {x: e.touches[0].clientX, y: e.touches[0].clientY}
      },
      iveBoxEnd() {
        this.scrollEndY = this.scrollTop
        this.scrollEndX = this.scrollLeft
        // this.endTouch = {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY}
      },
      toTop() {
        this.scrollEndY = 0
        this.scrollTop = 0
        this.$refs.tbodyes.style.transform = `translate(-${this.scrollLeft}px, -${0}px) scale(1) translateZ(0px)`
        this.$refs.fixedBody.style.transform = `translate(0px, -${0}px) scale(1) translateZ(0px)`
      },
      toBottom() {
        this.scrollEndY = this.maxTopLeft.top
        this.scrollTop = this.maxTopLeft.top
        this.$refs.tbodyes.style.transform = `translate(-${this.scrollLeft}px, -${this.maxTopLeft.top}px) scale(1) translateZ(0px)`
        this.$refs.fixedBody.style.transform = `translate(0px, -${this.maxTopLeft.top}px) scale(1) translateZ(0px)`
      }
    },
    components: {
      RenderTd
    },
    mounted() {
    },
    computed: {
      iveWidth() {
        let style = {}
        let width = 0
        this.header.forEach(col => {
          width += (col.width + 1)
        })
        style.width = `${width}px`
        return style
      },
      tableBody() {
        let style = {}
        style.width = this.iveWidth.width
        if (this.data) {
          style.height = `${this.data.length * (32 + 1)}px`
        }
        return style
      },
      iveBody() {
        let style = {}
        if (this.iveSize) {
          style.width = `${this.iveSize.width}px`
          style.height = `${this.iveSize.height - (this.iveHeadHeight || 34)}px`
        }
        return style
      },
      fixedHeaderEs() {
        let list = deepCopy(this.header)
        return list.filter(item => item.fixed)
      },
      leftFixedBoxStyle() {
        let width = 0
        let style = {}
        if (this.fixedHeaderEs) {
          this.fixedHeaderEs.forEach(col => {
            width += (col.width + 1)
          })
        }
        style.width = `${width}px`
        return style
      },
      leftIveWidth() {
        let style = {}
        style.width = this.leftFixedBoxStyle.width
        return style
      },
      iveLeftFixedBoxStyle() {
        let style = {}
        style.height = `${this.iveBody.height}`
        return style
      },
      leftTableBody() {
        let style = {}
        style.width = this.leftIveWidth.width
        style.height = this.tableBody.height
        return style
      },
      fixed() {
        return this.header.some(col => col.fixed && col.fixed === 'left')
      },
      maxTopLeft() {
        let obj = {}
        if (this.data) {
          obj.top = this.data.length * (32 + 1) - this.iveSize.height + (this.iveHeadHeight || 34)
          obj.left = parseInt(this.iveWidth.width || 0) - (this.iveSize.width || 0)
          // 15039
        }
        return obj
      },
      iveNotData() {
        return [
          'ive-not-data',
          {
            ['pitchOn']: this.iveNotStatus
          }
        ]
      }
    },
    beforeDestroy() {
    }
  }
</script>

<style lang="scss" scoped>
  .monthly {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .tap-bar {
      padding: 10px 10px 0;
      display: flex;

      .tap {
        width: 97px;
        height: 27px;
        background: url('~@/assets/imgs/tap15@2x.png') no-repeat;
        background-size: 100% 100%;
        font-size: 15px;
        color: #fff;
        text-align: center;
        line-height: 27px;
        padding-right: 10px;

        &.pitchOn {
          background: url('~@/assets/imgs/onTap15@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .tt-content {
      padding: 10px;
      overflow: hidden;
      height: calc(100vh - 126px);
      position: relative;

      .toTop {
        position: absolute;
        bottom: 50px;
        right: 20px;
        opacity: .5;
        height: 60PX;
        width: 30PX;

        .to-top, .to-bottom {
          width: 30PX;
          height: 30PX;
        }
      }

      .ive-box {
        height: 100%;
        overflow: hidden;
        position: relative;

        .ive-header {
          /*overflow-x: scroll;*/
          /*-webkit-overflow-scrolling: auto;*/
          position: relative;
          z-index: 1;

          table tr {
            th {
              .ive-th {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                word-break: break-all;
                box-sizing: border-box;
              }
            }
          }
        }

        .ive-body {
          /*overflow: scroll;*/
          /*-webkit-overflow-scrolling: auto;*/
          line-height: 30PX;

          table tr {
            td {
              .ive-tr-td {
                height: 100%;
                overflow: auto;
                box-sizing: border-box;
                padding: 0 3px;
                white-space: nowrap;
              }
            }
          }
        }

        .ive-left-fixed {
          position: absolute;
          top: 0;
          left: 0;
          overflow: hidden;
          z-index: 2;

          .ive-left-fixed-header {
            position: relative;
            z-index: 4;

            tr {
              th {
                .ive-table {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: normal;
                  word-break: break-all;
                  box-sizing: border-box;
                }
              }
            }
          }

          .ive-left-fixed-body {
            /*overflow-y: scroll;*/
            /*-webkit-overflow-scrolling: auto;*/

            table {
              tr {
                td {
                  .ive-tr-td {
                    height: 100%;
                    line-height: 32PX;
                    overflow: auto;
                    box-sizing: border-box;
                    padding: 0 3px;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }

        .ive-not-data {
          height: 32PX;
          width: 100%;
          text-align: center;
          line-height: 32PX;
          position: absolute;
          bottom: -34PX;
          left: 0;
          z-index: 5;
          background: #DFE2ED;
          transition: bottom .5s, opacity .5s;
          opacity: 0;

          &.pitchOn {
            bottom: -0PX;
            opacity: 1;
          }
        }
      }

      table.ive-table {
        transform: translate(0px, 0px) scale(1) translateZ(0px);

        thead {
          tr {
            background: #627FDE;
            color: #fff;

            th {
              height: 34PX;

              &.ive-header-left {
                text-align: left;
              }

              &.ive-header-center {
                text-align: center;
              }

              &.ive-header-right {
                text-align: right;
              }
            }
          }
        }

        tbody {
          tr {
            background: #DFE2ED;

            &:nth-child(2n) {
              background: #fff;
            }
          }
        }

        tr th, tr td {
          min-width: 0;
          box-sizing: border-box;
          text-align: left;
          text-overflow: ellipsis;
          vertical-align: middle;
          border-bottom: 1PX solid rgba(152, 156, 175, 1);

          &.ive-column-left {
            text-align: left;
          }

          &.ive-column-center {
            text-align: center;

            .td-down-of-up {
              justify-content: center;
            }
          }

          &.ive-column-right {
            text-align: right;

            .td-down-of-up {
              justify-content: flex-end;
            }
          }

          &.ive-hidden {
            visibility: hidden;
          }
        }
      }

      table tr td,
      table tr th {
        border-right: 1PX solid rgba(152, 156, 175, 1);
      }
    }
  }
</style>
